export default __webpack_public_path__ + "static/media/SeminarioIes2026_GiseleSosa.6f5ec8a3.jpg";